<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <Header/>

        <div class="bodyCenter">
            <div class="modalStyle">
                <div class="titulos">
                    <div class="seccionTitle">
                        <b-icon icon="building"></b-icon>
                        <div class="headerTxt mLeft">
                            Administracion de cuentas bancarias
                        </div>
                    </div>
                    <div class="alignIcon bold">?????</div>
                </div>

                <div class="noAlTope">
                    <b-tabs>
                        <b-tab title="Alta cuenta" active @click="activar(1)" >
                            <div v-if="activo === 1">
                                <alta/>
                            </div>
                        </b-tab>
                        <b-tab title="Asignación a clínica" @click="activar(2)" >
                            <div v-if="activo === 2">
                                <altaClinica/>
                            </div>
                        </b-tab>
                        <b-tab title="Editar cuenta/clínica" @click="activar(3)" >
                            <div v-if="activo === 3">
                                <altaClinica :mostrarEditar="true"/>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/Header.vue";
    import alta from "./AltaCuenta.vue";
    import altaClinica from "./AltaCuentasClinica.vue";

    export default {
        name: "Administracion",
        components: {
            Header,
            alta,
            altaClinica,
        },
        data: () => {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                activo: 1
            }
        },
        methods: {
            activar(value) {
                this.activo = value
            }
        },
      created() {
        this.debug = this.$localStorageService.getDebug();
      }
    };
</script>
